import { defineComponent, h } from 'vue';
import utils from '../../../../Shared/utils.jsx';

const SchemaItem = defineComponent({
    name: 'schema-item',
    data: () => ({
        schema: null,
        list: null,
    }),
    props: {
        name: null,
        cmodel: null,
        typeSchema: null,
        renamed: null,
        changed: null,
        deleted: null,
    },
    async created() {
        if (this.typeSchema) {

            const s = await utils.schema.get(this.typeSchema);
            this.schema = utils.schema.resolve_Of(s);
        }
        this.list = await utils.schema.get('/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/SchemaSchema');
    },
    render() {
        if (!this.list)
            return null;

        const options = [];
        let selected = false;
        for (let i = 0; i < this.list.anyOf.length; i++)
        {
            const opt = this.list.anyOf[i];

            if (this.schema && (this.schema.title === opt.title))
            {
                selected = true;
                options.push(<option selected value={opt.Id}>{opt.title}</option>);
            }
            else
                options.push(<option value={opt.Id}>{opt.title}</option>);
        }
        if (!selected)
            options.splice(0, 0, <option selected disabled value="">Please select one</option>);

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    <input type="text" value={this.name} onBlur={(e) => this.renamed(this.name, e.target.value)}></input>
                </td>
                <td>
                    <select style={{ width: "100%" }} onChange={(e) => this.changed(this.name, e.target.value)}>
                        {options}
                    </select>
                </td>
                <td>
                    <button onClick={() => this.deleted(this.name)}>x</button>
                </td>
            </tr>
        );
    }
});

export default defineComponent({
    name: 'schema-properties',
    components: {
        SchemaItem
    },
    data: () => ({
    }),
    computed: {
        ...utils.forms.computed,
    },
    props: {
        name: '',
        schema: null,
        schemakey: null,
        root: null,
        cmodel: null,
    },
    methods: {
        async itemChanged(prop, value) {
            let s = await utils.schema.get(value);
            s = utils.schema.resolve_Of(s);
            const m = utils.schema.createDefaultModel(s, this.root);
            this.cmodel[this.schemakey][prop] = m;
        },
        itemRenamed(prop, value) {
            const properties = this.cmodel[this.schemakey];
            const data = properties[prop];
            delete properties[prop];
            properties[value] = data;
        },
        itemDeleted(prop) {
            delete this.cmodel[this.schemakey][prop];
        },
        addAnother() {
            this.cmodel[this.schemakey].Unnamed = { };
        }
    },
    render() {
        const elements = [];
        const cmodel = this.cmodel[this.schemakey];
        for (let key in cmodel)
        {
            if (key.substr(0, 1) == '$') continue;
            const item = cmodel[key];

            elements.push(
                <SchemaItem
                    name={key}
                    cmodel={cmodel}
                    typeSchema={item.$typeSchema}
                    changed={(prop, value) => this.itemChanged(prop, value)}
                    renamed={(prop, value) => this.itemRenamed(prop, value)}
                    deleted={(prop, value) => this.itemDeleted(prop, value)}>
                </SchemaItem>);
        }

        return (
            <table>
                <tr>
                    <th>Property Name</th>
                    <th>Property Type</th>
                </tr>
                {elements}
                <tr>
                    <td colspan="2">
                        <button onClick={() => this.addAnother()}>Add Another</button>
                    </td>
                </tr>
            </table>
        );
    }
});